import styled from 'styled-components';
import { isTextRTL } from '../../utils/commonFunctions';

export const MessageContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  padding: 10px 18px 12px 18px;
`;

export const ChatContainer = styled.div<{ isSender?: boolean }>`
  display: flex;
  align-items: ${(props) => (props.isSender ? 'flex-start' : 'flex-end')};
  flex-direction: column;
  width: 100%;
  font-weight: 400;
`;

export const ChatDate = styled.div`
  margin-bottom: 10px;
  display: flex;
  justify-content: center;
  color: ${(props) =>
    props.theme.isVaultVariant
      ? props.theme.newPalette.neutral.N600
      : props.theme.atlas.semantic.color.type.muted};
`;

export const MessageBubble = styled.textarea<{ text: string }>`
  margin: 0 14px 0 0px;
  border: 1px solid
    ${(props) =>
      props.theme.isVaultVariant
        ? props.theme.newPalette.turquoise.T300
        : props.theme.atlas.semantic.color.action.primary.default};
  border-radius: 20px;
  background-color: ${(props) =>
    props.theme.isVaultVariant
      ? props.theme.newPalette.neutral.N0
      : props.theme.atlas.semantic.color.surface.default};
  direction: ${(props) => (isTextRTL(props.text) ? 'rtl' : 'ltr')};
  font-size: 14px;
  padding: 12px 0px 0px 12px;
  flex-grow: 2;
  white-space: pre-wrap;
  word-break: break-word;
  outline: none;
  font-style: italic;
  font-family: ${(props) => props.theme.typography.fontFamily};
  resize: none;
`;

export const SendIconContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-end;
  font-size: 32px;
  color: ${(props) =>
    props.theme.isVaultVariant
      ? props.theme.newPalette.turquoise.T300
      : props.theme.atlas.semantic.color.action.primary.default};
  margin-bottom: 6px;
`;
